(() => {
  const initializePasswordPage = (page) => {
    if (!page || page.dataset.passwordReady === 'true') return;
    page.dataset.passwordReady = 'true';

    const passwordInput = page.querySelector('[data-password-input]');
    const passwordToggle = page.querySelector('[data-password-toggle]');

    if (passwordInput && passwordToggle) {
      passwordToggle.addEventListener('click', () => {
        const reveal = passwordInput.type === 'password';
        passwordInput.type = reveal ? 'text' : 'password';
        passwordToggle.setAttribute('aria-pressed', reveal ? 'true' : 'false');
        passwordToggle.setAttribute('aria-label', reveal ? 'Hide password' : 'Show password');
        passwordInput.focus({ preventScroll: true });
      });
    }

    const successMessage = page.querySelector('[data-password-success]');
    if (successMessage) successMessage.focus({ preventScroll: false });

    const passwordError = page.querySelector('[data-password-error]');
    if (passwordError && passwordInput) passwordInput.focus({ preventScroll: false });

    const visual = page.querySelector('[data-password-visual]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (visual && !reducedMotion && window.matchMedia('(pointer: fine)').matches) {
      let animationFrame = 0;
      let pointerX = 0;
      let pointerY = 0;

      const renderParallax = () => {
        animationFrame = 0;
        const bounds = visual.getBoundingClientRect();
        if (!bounds.width || !bounds.height) return;
        const x = ((pointerX - bounds.left) / bounds.width - 0.5) * 8;
        const y = ((pointerY - bounds.top) / bounds.height - 0.5) * 8;
        visual.style.setProperty('--password-parallax-x', `${x.toFixed(2)}px`);
        visual.style.setProperty('--password-parallax-y', `${y.toFixed(2)}px`);
      };

      visual.addEventListener('pointermove', (event) => {
        pointerX = event.clientX;
        pointerY = event.clientY;
        if (!animationFrame) animationFrame = window.requestAnimationFrame(renderParallax);
      }, { passive: true });

      visual.addEventListener('pointerleave', () => {
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        animationFrame = 0;
        visual.style.setProperty('--password-parallax-x', '0px');
        visual.style.setProperty('--password-parallax-y', '0px');
      }, { passive: true });
    }
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-password-page]').forEach(initializePasswordPage);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
